import { useCallback, useEffect, useState } from 'react';

import useGetImagesParams from 'hooks/Meteorology/Weather/SeasonalForecast/useGetImagesParams';
import { useLazyGetSeasonalForecastImagesQuery } from 'services/api/Meteorology/Weather/SeasonalForecast';
import { ResponseError } from 'services/api/base';

export default function useImages() {
  const params = useGetImagesParams();
  const [trigger, { data, error, isFetching }] = useLazyGetSeasonalForecastImagesQuery();
  const [image, setImage] = useState('');

  const onRetry = useCallback(() => {
    if (params) trigger(params);
  }, [params, trigger]);

  useEffect(() => {
    if (!params) {
      setImage('');
    } else {
      trigger(params);
    }
  }, [params, trigger]);

  useEffect(() => {
    if (data) setImage(data);
  }, [data]);

  return {
    image,
    queryError: error as ResponseError | undefined,
    onRetry,
    loading: isFetching,
  };
}
